<template lang="pug">
  .alert-panel
    div
      img.alert-icon(src="@/assets/img/sound.svg")
      h5.alert-option Alert Option
      CustomCheckbox.alert-checkbox(:value="value" @input="alerter")
        span.body-1 &nbsp;Play sound when new transaction is received
</template>

<script>
import CustomCheckbox from '@/components/CustomCheckbox'

export default {
  name: 'AlertPanel',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    alerter: function() {
      this.$emit('input', !this.value)
    },
  },
  components: {
    CustomCheckbox,
  },
}
</script>

<style lang="scss" scoped>
.alert-panel {
  padding: 0.8rem;
  margin: 2rem 0;
  border: 1px solid #e6e6e6;
}
.alert-icon {
  width: 1.3rem;
}

.alert-option {
  display: inline;
  padding-left: 1rem;
}

.alert-checkbox {
  display: block;
  margin-top: 0.8rem;
}
</style>
